import * as z from "zod/v4";

export const recoverConversationGroupKeys = [
  "marketingConversationId",
  "automation",
  "automationStepId",
  "treatmentId",
] as const;

export type RecoverConversationGroupKey = Partial<
  Record<(typeof recoverConversationGroupKeys)[number], string | null>
>;

export const RecoverConversationGroupKeySchema = z
  .object({
    marketingConversationId: z.string().nullish(),
    automation: z.string().nullish(),
    automationStepId: z.string().nullish(),
    treatmentId: z.string().nullish(),
  })
  .partial();

export const validRecoverConversationGroupings: Set<
  keyof RecoverConversationGroupKey
>[] = [
  new Set([]),
  new Set(["marketingConversationId"]),
  new Set(["automation"]),
  new Set(["automation", "automationStepId"]),
  // A/B testing groupings
  new Set(["treatmentId"]),
  new Set(["automation", "treatmentId"]),
  new Set(["automation", "automationStepId", "treatmentId"]),
];

export const recoverConversationMetrics = [
  "initialSends",
  "replySends",
  "customerReplies",
  "uniqueCustomerReplies",
  "recoveredOrders",
  "recoveredRevenue",
  "unsubscribes",
  "skippedDueToUnsubscribe",
  "skippedDueToSkipConditions",
  "checkoutAbandonments",
] as const;

export type RecoverConversationMetric =
  (typeof recoverConversationMetrics)[number];
